<template>
  <div>
        <v-row class="ma-4">
          <p>Dados Técnicos do stringbox</p>
        </v-row>
        <v-row>

             <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.nInputs"
          label="Número de entradas"
          v-bind:options="optionsInteger"
        />
      </v-col>
             <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.nOutputs"
          label="Número de saídas"
          v-bind:options="optionsInteger"
        />
      </v-col>
     
    </v-row>
  </div>
</template>



<script>
export default {
  components: {
    // EditModulo
  },
  mounted() {},

  name: "edit-stringbox",

  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  props: ["device"],
  data() {
    return {
      selected: [],
       optionsInteger: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 0,
      },
      optionsBr: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 2,
      },
    };
  },

  methods: {},
};
</script>
